import React from 'react'
import styled from "styled-components";
import * as media from "../../../media";
import DesktopMap from './Desktop'
import MobileMap from './Mobile'
import Loader from "../../../basic/LoaderCircle";
import Map from '../../yandex-map/index'
import {compose, lifecycle, withState} from "recompose";
import _ from "lodash";
import getUrl from "../../../getUrl";
/*import PinBlue from '../../../static/map_pin_blue.svg'
import PinRed from '../../../static/map_pin_red.svg'*/
// TODO иконки из дизайна очень неудачно смотрятся
import PinBlue from '../../../static/map_pin.png'
import PinRed from '../../../static/map_pin_active.png'
import CurrentLanguageContext from '../../../context/currentLanguageContext';


const BiggerThan1000Check = styled.div`
  ${media.smallerThan(1000)`display:none;`}
`
const LessThan1000Check = styled.div`
  ${media.biggerThan(1001)`display:none;`}
`

function MapWrapper(props) {
  return (
    props.loading
      ? <Loader/>
      : <Map {...props}/>
  )
}

function FinwhaleMap(props) {
  const {finsalepoints, distributors, loadingPoints, loadingDistributors, mapObjectTypes, mapLoadingFailed, setMapLoadingFailed} = props
  if (mapLoadingFailed) {
    return null
  }
  return (
    <CurrentLanguageContext.Consumer>
      {currentLanguage => ['en', 'ua'].indexOf(currentLanguage) !== -1 ? null : (
        <div>
          <BiggerThan1000Check>
            <DesktopMap {...props} />
          </BiggerThan1000Check>
          <LessThan1000Check>
            <MobileMap {...props} />
          </LessThan1000Check>
          <MapWrapper
            objects={mapObjectTypes === 'distributors' ? distributors : finsalepoints}
            loading={loadingDistributors || loadingPoints}
            pinActive={mapObjectTypes === 'distributors' ? PinBlue : PinRed}
            pin={mapObjectTypes === 'distributors' ? PinRed : PinBlue}
            mapLoadingFailed={mapLoadingFailed}
            setMapLoadingFailed={setMapLoadingFailed}
            currentLanguage={currentLanguage}
          />
        </div>
      )}
    </CurrentLanguageContext.Consumer>
  )
}

const enhance = compose(
  withState('mapObjectTypes', 'setMapObjectTypes', 'distributors'),
  withState('mapLoadingFailed', 'setMapLoadingFailed', false),
  lifecycle({
    state: {loadingPoints: true, loadingDistributors: true},
    componentDidMount() {
      fetch(getUrl(`/cat/v1/dict/finsalepoints`)).then(data => {
        return data.json()
      }).then(listItems => {
        const finsalepoints = _.get(listItems, 'data.data')
        this.setState({finsalepoints, loadingPoints: false})
      }).catch(err => {
        console.log(err)
      })

      fetch(getUrl(`/cat/v1/dict/distributors`)).then(data => {
        return data.json()
      }).then(listItems => {
        const distributors = _.get(listItems, 'data.data')
        this.setState({distributors, loadingDistributors: false})
      }).catch(err => {
        console.log(err)
      })
    }
  }),
)

export default enhance(FinwhaleMap)



// WEBPACK FOOTER //
// ./src/finwhale/common/fw-map/index.js